import { FileExtension } from '@/modules/shared/schemas/FileExtension'

import { axios, Response } from '../index'

export type Body = {
  newGroupName?: string
  newGroupImageRequest?: NewGroupImageRequest
  newGroupHeaderRequest?: NewGroupImageRequest
}

export type NewGroupImageRequest = {
  fileName: string
  fileContentType: FileExtension
  originalFileName: string
}

const updateGroupInfos = (groupId: string, body: Body): Response<null> => {
  return axios.put(`/v1/groups/${groupId}`, body)
}

export default updateGroupInfos
